/* src/app/modules/portal/components/service-tickets-page/service-tickets-shared.scss */
.tickets-mobile {
  margin-top: 1rem;
  gap: 1rem;
  display: flex;
  flex-direction: column;
}
.tickets-mobile .ticket {
  gap: 0.5rem;
  padding: 1rem;
  box-shadow: var(--shadow-raised);
  border-radius: var(--sh-card-border-radius);
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.tickets-mobile .ticket .item {
  display: flex;
  flex-direction: column;
  width: calc(50% - 1rem);
}
.tickets-mobile .ticket .item > span:last-child {
  font-weight: 400;
}
.ticket[color=yellow] {
  border-left: 4px solid #ffd201;
}
.ticket[color=green] {
  border-left: 4px solid #009a38;
}
.ticket[color=red] {
  border-left: 4px solid #e7001d;
}
.ticket[color=grey] {
  border-left: 4px solid #808080;
}
.linebreak {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
[screen-phone] :host-context [hide-phone],
[screen-tablet] :host-context [hide-phone] {
  display: none;
}
/*# sourceMappingURL=service-tickets-shared.css.map */
